import { useState, useEffect, useCallback, useMemo } from "react";
import { debounce } from "lodash";
import { useDealers } from "~/entity/Dealers";

export const useDealersForSelect = () => {
  const { dealersMy } = useDealers();

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [currentPartName, setCurrentPartName] = useState("");
  const [currentFederalArea, setCurrentFederalArea] = useState("");
  const [currentFederalAreaEn, setCurrentFederalAreaEn] = useState("");
  const [currentRegion, setCurrentRegion] = useState("");
  const [currentRegionEn, setCurrentRegionEn] = useState("");
  const LIMIT = 25;

  const loadDealers = useCallback(
    async (page = 1, append = false) => {
      if (loading) return;
      setLoading(true);
      try {
        const response = await dealersMy(
          LIMIT,
          page,
          currentPartName,
          currentRegion,
          currentRegionEn,
          currentFederalArea,
          currentFederalAreaEn
        );

        const { dealers } = response.data;
        const { data: dealersData, pagination } = dealers;

        const mappedDealers = dealersData.map(({ id, dealerName }) => ({
          label: dealerName,
          value: id,
        }));

        if (append) {
          setOptions((prev) => [...prev, ...mappedDealers]);
        } else {
          setOptions(mappedDealers);
        }

        setCurrentPage(page);
        setHasMore(pagination.hasNext);
      } catch (error) {
        console.error("Ошибка загрузки дилеров:", error);
      } finally {
        setLoading(false);
      }
    },
    [
      dealersMy,
      loading,
      currentPartName,
      currentRegion,
      currentRegionEn,
      currentFederalArea,
      currentFederalAreaEn,
    ]
  );

  useEffect(() => {
    setCurrentPage(1);
    loadDealers(1, false);
  }, [
    currentPartName,
    currentRegion,
    currentRegionEn,
    currentFederalArea,
    currentFederalAreaEn,
  ]);

  useEffect(() => {
    loadDealers(1, false);
  }, []);

  const onScrollBottom = useCallback(() => {
    if (hasMore && !loading) {
      loadDealers(currentPage + 1, true);
    }
  }, [hasMore, loading, currentPage, loadDealers]);

  const searchDealers = useMemo(
    () =>
      debounce((partName = "") => {
        setCurrentPartName(partName);
      }, 300),
    []
  );

  const setFederalAreaFilter = useCallback((federalArea = "", isEn = false) => {
    if (isEn) {
      setCurrentFederalAreaEn(federalArea);
      setCurrentFederalArea("");
    } else {
      setCurrentFederalArea(federalArea);
      setCurrentFederalAreaEn("");
    }
  }, []);

  const setRegionFilter = useCallback((region = "", isEn = false) => {
    if (isEn) {
      setCurrentRegionEn(region);
      setCurrentRegion("");
    } else {
      setCurrentRegion(region);
      setCurrentRegionEn("");
    }
  }, []);

  return {
    options,
    loading,
    onScrollBottom,
    searchDealers,
    setFederalAreaFilter,
    setRegionFilter,
  };
};
